export const rulesConstants = {
  MAX_BET_COUNT: 12,
  MIN_TICKET_PAYIN: 8,
  MIN_TICKET_PAYIN_SINGLE: 9,
  MAX_TICKET_PAYIN: 10,
  MAX_TICKET_PAYIN_PER_BET: 11,
  MAX_WINNING: 14,
  MIN_TICKET_PAYIN_PER_COMBINATIONS_2: 23,
  MAX_NUMBER_OF_BANKERS: 20,
  MAX_NUMBER_OF_NON_BANKERS: 21,
};

export const ticketTypes = {
  COMBO: 1,
  SYSTEM: 2,
  SINGLE: 3,
};
